/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class RateCardService {
  private baseUrl: string = environment.host + '/compensation';
  private pricetierUrl: string = environment.host + '/pricetier';
  private matchingRateCardUrl = environment.host + '/getmatchingRatecard';
  private materialGroupUrl = environment.host + '/productgroup';
  private baseOverridesUrl: string = environment.host + '/overrides';
  private flagsUrl: string = environment.host + '/flag/metadata?tabType=' + 'flagPage/ratecard';
  private advisorsRecruitmentTypesURL = environment.host + '/advisorsRecruitmentTypes';
  
  constructor(private http: HttpClient) {}

  public getAllGlobalCompensationsRecordsTabType() {
    const compensationurl = this.baseUrl.toString();
    return this.http.get(compensationurl + '/global' + '?tabType=compensationPage/ratecard').toPromise();
  }

  public getAllPlanCompensationsRecordsTabType(planId: any) {
    const compensationurl = this.baseUrl.toString() + '/' + planId + "?tabType=" + 'bonusview/ratecardview';
    return this.http.get(compensationurl).toPromise();
  }

  public getCompensationMetaData() {
    const metadataUrl = this.baseUrl.toString() + '/metadata?tabType=' + 'compensationPage/ratecard';
    return this.http.get(metadataUrl).toPromise();
  }

  public getAllRecords(planId: any) {
    const rateCardUrl = this.baseUrl.toString() + '/ratecard/' + planId;
    return this.http.get(rateCardUrl).toPromise();
  }

  public getAllRecordsTabType(planId: any) {
    const rateCardUrl = this.baseUrl.toString() + '/ratecard/' + planId + '?tabType=' + 'CompensationRatecardview';
    return this.http.get(rateCardUrl).toPromise();
  }

  public saveAllRecords(payload: any) {
    const rateCardUrl = this.baseUrl.toString() + '/ratecard';
    return this.http.post(rateCardUrl, payload).toPromise();
  }

  public getAllPriceTiers() {
    return this.http.get(this.pricetierUrl.toString()).toPromise();
  }

  public getMatchingRateCard(code: string) {
    const url = this.matchingRateCardUrl.toString() + '/' + code;
    return this.http.get(url).toPromise();
  }

  public getVCRuleConditionsMetaData() {
    const url = environment.host + '/valuechainrules/condition/';
    return this.http.get(url).toPromise();
  }

  public getMaterialsMetaData() {
    const url = environment.host + '/productCategory';
    return this.http.get(url).toPromise();
  }

  public getMaterialsMetaDataTabType() {
    const url = environment.host + '/productCategory?tabType=' + 'materialPage/ratecards';
    return this.http.get(url).toPromise();
  }

  public getMaterialsMetaDataEarningProgram(volumeCode: any) {
    const url = environment.host + '/productCategory/' + volumeCode;
     return this.http.get(url).toPromise();
   }

  public getAllMaterialGroup(){
    return this.http.get(this.materialGroupUrl.toString()).toPromise();
  }

  public getAllMaterialGroupTabType(){
    const URL=this.materialGroupUrl+ '?tabType=materialPage/ratecards';
    return this.http.get(URL.toString()).toPromise();
  }

  public getRateCardHistoryDetails(id: string) {
    const url = environment.host + '/compensation/compratecard/' + id;
    return this.http.get(url).toPromise();
  }

  public closeRegionRateCard(id: string | number) {
    const url = environment.host + '/compensation/comprateregioncard/' + id;
    return this.http.post(url, {}).toPromise();
  }

  public getValueChainConfigsMetadata() {
    const url = environment.host + '/valuechainconfigs';
    return this.http.get(url).toPromise();
  }

  public getValueChainConfigsMetadataTabType() {
    const url = environment.host + '/valuechainconfigs?tabType=' + 'valuechainPage/ratecard';
    return this.http.get(url).toPromise();
  }

  public getExpiredExceptionRatesDetails(compRateCardChannelUnitId: string) {
    const url = environment.host + '/compensation/expiredExceptionRates/' + compRateCardChannelUnitId;
    return this.http.get(url).toPromise();
  }

  public downloadMaterials(compRateCardId: string) {
      const url = environment.host + '/compRateRegionCard/downloadMaterials/' + compRateCardId;
      return this.http.get(url).toPromise();
  }

  public delimitExceptionRateCard(exceptionRate: any, regionCardFromDate: any, regionCardToDate: any ){
    const url = environment.host + '/delimitExceptionRateCard/' + regionCardFromDate + '/' +regionCardToDate;
    return this.http.post(url,exceptionRate).toPromise();
  }

  public delimitBaseRateCard(rateCardId: number,regionCard: any){
    const url = environment.host + '/delimitBaseRateCard/'+ rateCardId;
    return this.http.post(url,regionCard).toPromise();
  }

  public getCurrentPeriodDate(companyCode: any) {
    if (companyCode) {
      const url = environment.host + '/period?companyCode=' + companyCode;
      return this.http.get(url).toPromise();
    }
  }

  public downloadReport(compRateRegionCardId: string) {
    const url = environment.host + '/compRateRegionCard/download/' + compRateRegionCardId;
    return this.http.get(url).toPromise();
  }

  public getPlanVolumeDefinitions(planId: any) {
    let url = environment.host + '/plan/' + planId + '/volume-definitions';
    return this.http.get(url).toPromise();
  }

  public getPlanVolumeDefinitionsTabType(planId: any) {
    let url = environment.host + '/plan/' + planId + '/volume-definitions?tabType=' + 'volumeconfigurationview/ratecard';
    return this.http.get(url).toPromise();
  }

  public validateExpression(payload:any){
    const url = environment.host + '/validate/expressionRuleSet' ;
    return this.http.post(url,payload).toPromise();
  }

  public getChallengeProgramMetaData() {
    const url = environment.host + '/challengeProgramMetadata';
    return this.http.get(url.toString()).toPromise();
  }

  public getChallengeProgramMetaDataTabType() {
    const url = environment.host + '/challengeProgramMetadata?tabType=challengeprogrammetadata/ratecards';
    return this.http.get(url.toString()).toPromise();
  }

  public getAllMaterialGroups() {
    const url = environment.host + '/volumeconfig/materialgroups';
    return this.http.get(url).toPromise();
  }

  public getCriteriaRequirements() {
    const url = environment.host + '/challengeProgram/CriteriaRequirement';
    return this.http.get(url).toPromise();
  }

  public getAllCompensationOverrides() {
    return this.http.get(this.baseOverridesUrl.toString() + '/category/Compensation?tabType=' + 'overridePage/ratecard').toPromise();
  }

  public getAllFlags() {
    return this.http.get(this.flagsUrl.toString()).toPromise();
  }

  public getAllAdvisorsRecruitmentTypes(){
    return this.http.get(this.advisorsRecruitmentTypesURL.toString()).toPromise();
  }

}
